var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGeoDisabled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#geo-disabled_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M19.51 4.504 6.45 10.463h6.038c.69 0 1.25.56 1.25 1.25v5.758l5.771-12.967zm-.023-1.638c1.048-.478 2.13.594 1.661 1.645L14.63 19.155c-.549 1.233-2.392.842-2.392-.508v-6.684H5.3c-1.344 0-1.741-1.83-.52-2.388z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "geo-disabled_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 3h18v18H3z"
})))));
export default SvgGeoDisabled;